import { FC } from "react";
import { Link } from "../Link";

interface SectionHeaderButtonProps {
    url?: string;
    title: string;
    onClick?: () => void;
}
export const SectionHeaderButton: FC<SectionHeaderButtonProps> = ({
    url,
    title,
    onClick,
}) => {
    const className = "transition-all bg-slate-200 px-4 py-2 rounded-full cursor-pointer active:scale-95 hover:bg-sky-600 hover:text-white text-sky-900 hover:no-underline hover:shadow-sm";

    if (onClick) {
        return (
            <div className={className}>{title}</div>
        );
    }

    if (url) {
        return (
            <Link to={url} className={className}>{title}</Link>
        );
    }

    return null;
}